export class ServerResponse<T> {
    Result: ServerResult<T>;
}
export class ServerResult<T> {
    Message: string;
    ReturnCode: number;
    Resultset: T[];
    Id_Session: string;
    Id_User: number;
    EMail: string;
    Region: string;
    Sex: boolean;
    Id_Recipe: number;
    Id_PlanStage: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/server-response-model.ts